import {useQuery} from "@tanstack/react-query";
import React from "react";
import {readCustomerTypeSelectBoxApi} from "../../../../../api/correspondent/CorresspondentApi";

type Props = {};

/**
 * 업체 관계 셀렉트박스
 * @param props
 * @returns
 */
export const useReadCustomerTypeSelect = () => {
    const {data} = useQuery({
        queryKey: ["readCustomerTypeSelect"],
        queryFn: async () => await readCustomerTypeSelectBoxApi(),
        select: (res) => res?.result ?? null,
        // staleTime: 6000 * 10,
    });

    return {data};
};
